import { MarketingLayout, Hero, FinalCta } from "../components/MarketingLayout";
import { useSeo } from "../lib/useSeo";

const PLANS = [
  {
    name: "GP Practices",
    price: "Free",
    note: "For GP practices using SimplyRefer to search clinicians, check availability and complete the referral option that suits their usual workflow.",
    testId: "plan-gp",
  },
  {
    name: "Individual",
    price: "$39",
    period: "/month",
    note: "For an individual psychologist or psychiatrist managing their own profile and availability.",
    testId: "plan-individual",
  },
  {
    name: "Clinic Light",
    price: "$99",
    period: "/month",
    note: "For small clinics managing multiple clinicians.",
    testId: "plan-clinic-light",
    featured: true,
  },
  {
    name: "Clinic Plus",
    price: "$189",
    period: "/month",
    note: "For larger clinics needing broader clinic visibility and multiple clinician profiles.",
    testId: "plan-clinic-plus",
  },
];

export default function PricingPage() {
  useSeo({
    title: "SimplyRefer Pricing | GP Practices, Clinicians and Clinics",
    description:
      "SimplyRefer is free for GP practices. Individual practitioners and clinics have simple monthly plans.",
    canonicalPath: "/pricing",
  });

  return (
    <MarketingLayout active="/pricing">
      <Hero
        eyebrow="Pricing"
        h1="Free for GP practices. Simple plans for practitioners and clinics."
      />

      <section className="bg-white">
        <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="pricing-plans">
            {PLANS.map((p) => (
              <div
                key={p.name}
                className={`flex flex-col rounded-xl border bg-white p-6 ${p.featured ? "border-primary ring-1 ring-primary/20" : "border-slate-200"}`}
                data-testid={p.testId}
              >
                {p.featured && (
                  <span className="mb-3 inline-block w-fit rounded-md bg-secondary px-2 py-0.5 text-xs font-semibold text-secondary-foreground">
                    Most popular
                  </span>
                )}
                <h2 className="font-heading text-lg font-semibold text-slate-900">{p.name}</h2>
                <p className="mt-2">
                  <span className="font-heading text-2xl font-semibold text-primary">{p.price}</span>
                  {p.period && <span className="text-sm text-slate-400">{p.period} AUD</span>}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">{p.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCta
        heading="Ready to get started?"
        primary={{ to: "/signup/gp", label: "Get early GP practice access" }}
        secondary={{ to: "/clinician/signup", label: "Join the directory" }}
      />
    </MarketingLayout>
  );
}
